export default {
  aggregations: [],
  terms: [],
  aggregation: null,
  loading: true,
};
